import { autoinject, transient } from "aurelia-dependency-injection";
import { Claims } from "../../../../../../constants/authentication/claims";
import { LookupValue } from "../../../../../../models/lookups/lookup.models";
import { RightShipInspectionModel, RightShipInspectionType } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Reflection } from "../../../../../../utilities/reflection";
import { computedFrom } from "aurelia-binding";

@autoinject
@transient()
export class AgentDetailsTab {
    
    item:RightShipInspectionModel;
    agentOfficeCountryCode: string;
    isEdit: boolean;
    canModifyInspectorAppointment: boolean;
    activate(item:RightShipInspectionModel){
        this.item = item;
    }

    constructor(userClaimsService:UserClaimsService)
    {
        this.canModifyInspectorAppointment = userClaimsService.hasPermission(Claims.CanModifyInspectorAppointment);
    }

    @computedFrom(Reflection.getPropertyPath<AgentDetailsTab>(z => z.item),
    Reflection.getPropertyPath<AgentDetailsTab>(z => z.item.rightShipInspectionTypeId))
    get isCargill() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.CargillSurvey;
    }

    @computedFrom(Reflection.getPropertyPath<AgentDetailsTab>(z => z.item),
    Reflection.getPropertyPath<AgentDetailsTab>(z => z.item.rightShipInspectionTypeId))
    get isDry() {
        return this.item && this.item.rightShipInspectionTypeId == RightShipInspectionType.RightShipInspection;
    }

    inspectorDisplayName: (item: LookupValue) => string = (item: LookupValue) => {
        if(item)
        {
            return item.additionalData && item.additionalData.accreditationStatus? `${item.name} - ${item.additionalData.accreditationStatus}` : item.name;
        }
        
        return "";
    }
}